import React, { useRef } from "react";
import { toolsAPI } from "../../utils/funcionesAPI";
import {
  gtag_report_conversion,
  manejadorDeRespuesta,
  validateEmail,
} from "../../utils/Tools";
import { toast, ToastContainer } from "react-toastify";
import { withRouter } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

const Contacto = (props) => {
  window.scrollTo(0, 0);

  const recaptcha = useRef(null);

  function handleEnviarCVClick(e) {
    e.preventDefault();
    if (!recaptcha.current.getValue()) {
      toast.info("Por favor valide el Captcha", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }
    var form = e.target.parentNode.parentNode;
    const formulario = {
      nombre: form[0].value,
      mail: form[1].value,
      telefono: form[2].value,
      asunto: form[3].value,
      consulta: form[4].value,
    };

    if (!validateEmail(formulario.mail)) {
      toast.info("El e-mail debe tener un formato válido", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    let data = JSON.stringify({
      accion: "enviarMailDeContacto",
      formulario: formulario,
    });
    toast.info("Enviando...", {
      position: toast.POSITION.BOTTOM_CENTER,
    });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        toast.success(respuesta.data, {
          position: toast.POSITION.BOTTOM_CENTER,
          onClose: () => props.history.push("/"),
        });

      //  document.getElementById("formContacto").reset();
    });

    const { location } = props || {};
    const { pathname = "" } = location || {};
    gtag_report_conversion(pathname, "CONTACTO");
  }

  return (
    <section className="sobre-pedraza">
      <div className="container">
        <div className="row col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <article className="txt ">
            <h1>Contacto</h1>
            <hr />
            <h6>Estimado Cliente:</h6>
            <p>
              Antes de enviarnos un mail por consultas de viajes, recuerde que
              nuestra página opera Totalmente Online, es decir, que toda la
              información sobre nuestros tours, fechas de salidas con lugares
              disponibles, tarifas y formas de pago se encuentran actualizadas.
            </p>

            <h6>
              Ventajas de operar con nuestro Website en forma Ágil y rápida:
            </h6>
            <ul>
              <li>- Efectuar su reserva online.</li>
              <li>
                - Pagar online con tarjeta de crédito o deposito bancario.
              </li>
              <li>- Seguimiento de su reserva.</li>
              <li>- Emitir su vouchers de viaje.</li>
            </ul>
          </article>
        </div>
        <form
          id="formContacto"
          className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
        >
          <div className="form-group ">
            <label className="labelForm" htmlFor="nombre">
              Nombre y Apellido
            </label>
            <input
              className="form-control"
              type="text"
              name="nombre"
              placeholder="Nombre y Apellido"
              required
            />
          </div>

          <div className="form-group ">
            <label className="labelForm" htmlFor="mail">
              E-Mail
            </label>
            <input
              className="form-control"
              type="text"
              name="mail"
              placeholder="E-mail"
              required
            />
          </div>

          <div className="form-group ">
            <label className="labelForm" htmlFor="telefono">
              Telefono
            </label>
            <input
              className="form-control"
              type="text"
              name="telefono"
              placeholder="Telefono"
              required
            />
          </div>

          <div className="form-group ">
            <label className="labelForm" htmlFor="asunto">
              Asunto
            </label>
            <input
              className="form-control"
              type="text"
              name="asunto"
              placeholder="Asunto"
              required
            />
          </div>

          <div className="form-group ">
            <label className="labelForm" htmlFor="consulta">
              Consulta
            </label>
            <textarea
              rows="6"
              className="form-control"
              name="consulta"
              placeholder="Consulta"
              required
            />
          </div>

          <div className="form-group">
            {/* <ReCAPTCHA
              sitekey="6LeJS0oqAAAAAPTINcrbGa9KrQOByv6V3MIq9iU9"
              ref={recaptcha}
            /> */}
            <ReCAPTCHA sitekey="6LenTkoqAAAAAMHq2--L9dT5dW9vYs3eetsUErrp" ref={recaptcha} />
          </div>

          <p className="contenedorLinkInicio col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
            <input
              className="botonInicio"
              type="submit"
              value="Enviar"
              onClick={handleEnviarCVClick}
            />
          </p>


        </form>
        <ToastContainer />
      </div>
    </section>
  );
};

export default withRouter(Contacto);



// WEBPACK FOOTER //
// ./src/components/Global/Contacto.js